import { Action } from '../core';

const GYM_ACCESS_EVENTS_GET_MANY = { entity: 'GYM_ACCESS_EVENTS', action: Action.GET_MANY };
const GYM_ACCESS_RULES_GET = { entity: 'GYM_ACCESS_RULES', action: Action.GET };
const GYM_ACCESS_RULES_SAVE = { entity: 'GYM_ACCESS_RULES', action: Action.HANDLE };

export { GYM_ACCESS_EVENTS_GET_MANY, GYM_ACCESS_RULES_GET, GYM_ACCESS_RULES_SAVE };
